/* eslint-disable @next/next/no-img-element */
import type { ImgHTMLAttributes } from 'react';

/**
 * Plain <img> for marketing photos. The prototype uses native <img> with the
 * marketing CSS controlling sizing; we keep that (the app's next/image custom
 * Supabase loader is for app content, not static marketing assets). Single
 * eslint-disable lives here so pages stay clean.
 */
export function MarketingImage(props: ImgHTMLAttributes<HTMLImageElement>) {
  return <img {...props} />;
}
